import PerformanceRepository from "@/repositories/PerformanceRepository";

export default {
    name: 'performance',
    namespaced: true,
    state: {
        list: [],
        isLoading: false
    },
    getters: {
        all (state) {
            return state.list
        },
        isLoading (state) {
            return state.isLoading
        }
    },
    mutations: {
        setAll (state, array) {
            state.list = array
        },
        setLoading (state, boolean) {
            state.isLoading = boolean
        }
    },
    actions: {
        async listAll ({ commit }, params) {
            commit('setLoading', true)
            await PerformanceRepository.fetchAll(params).then(response => {
                commit('setAll', response.data.data)
            })
            commit('setLoading', false)
        }
    }
}
